import { render, staticRenderFns } from "./EmailMessageItem.vue?vue&type=template&id=1fa2d756&scoped=true&"
import script from "./EmailMessageItem.vue?vue&type=script&lang=js&"
export * from "./EmailMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessageItem.vue?vue&type=style&index=0&id=1fa2d756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa2d756",
  null
  
)

export default component.exports